var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 51,
    viewBox: "0 0 60 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1899 35.6778L30.009 25.4961L19.8281 35.6778",
    stroke: "#20A8E0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0117 25.4961V48.4048",
    stroke: "#20A8E0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3654 41.7629C53.8478 40.4094 55.8089 38.2677 56.9391 35.6758C58.0693 33.084 58.3042 30.1895 57.6068 27.4492C56.9094 24.709 55.3193 22.279 53.0877 20.5429C50.856 18.8068 48.1097 17.8633 45.2823 17.8614H42.0753C41.3049 14.8814 39.869 12.1148 37.8756 9.76956C35.8821 7.42436 33.383 5.56162 30.5661 4.32139C27.7492 3.08115 24.6878 2.49569 21.6121 2.60902C18.5363 2.72235 15.5263 3.53153 12.8083 4.97571C10.0903 6.41989 7.735 8.46149 5.91952 10.947C4.10404 13.4326 2.87561 16.2974 2.32658 19.3261C1.77755 22.3547 1.92221 25.4685 2.74968 28.4332C3.57715 31.3979 5.0659 34.1365 7.10401 36.443",
    stroke: "#20A8E0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1899 35.6778L30.009 25.4961L19.8281 35.6778",
    stroke: "#20A8E0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/Upload_icon.a0b1c5b8bf1dc5b9ab50b2d2ff07fba1.svg";
export { ForwardRef as ReactComponent };